export default "__VITE_ASSET__3f998337__"